var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};

OCS.WxBriefing.Classes.Manager = new Class({
    Implements: [Options, Events],
    adv_manager: null,
    data_manager: null,
    events: {},
    initialize: function (op) {
        this.init(op);
    },
    init: function (op) {

    },
    get_adv_manager: function () {
        this.get_data_manager();
        var manager_class = this.get_adv_manager_class();
        if (!manager_class) {
            OCS.DynamicScriptLoader.load({
                load: OCS.Bootstrap.load_file_paths.viewer,
                complete: function () {
                    if (!this.adv_manager) {
                        this.adv_manager = new manager_class(this.options.adv_manager_ops);
                    }
                }.bind(this)
            });
        } else {
            if (!this.adv_manager) {
                this.adv_manager = new manager_class(this.options.adv_manager_ops);
            }
            return this.adv_manager;
        }
    },
    get_adv_manager_class: function () {
        return OCS.Viewer.Classes.AdvisoryManager;
    },
    get_data_manager: function () {
        var data_manager_class = this.get_data_manager_class();
        if (!OCS.Viewer.Classes.DataManager) {
            OCS.DynamicScriptLoader.load({
                load: OCS.Bootstrap.load_file_paths.viewer,
                complete: function () {
                    if (!this.data_manager) {
                        this.data_manager = new data_manager_class(this.options.data_manager_ops);
                    }
                }.bind(this)
            });
        } else {
            if (!this.data_manager) {
                this.data_manager = new data_manager_class(this.options.data_manager_ops);
            }
            return this.data_manager;
        }
    },
    get_data_manager_class: function () {
        return OCS.Viewer.Classes.DataManager;
    },
    remove_registered_events: function () {
        var em = OCS.WxBriefing.Functions.get_event_manager();
        Object.each(this.events, function (event_key) {
            em.unsubscribe(event_key);
        }.bind(this));
        this.events = {};
    }
}); // End OCS.WxBriefing.Classes.managers
OCS.WxBriefing.Classes.SingletonManager = new Class({
    Extends: OCS.WxBriefing.Classes.Manager,
    initialize: function (op) {
        if (!this.manager_name) {
            return null;
        }
        if (OCS.WxBriefing.Live[this.manager_name]) {
            return OCS.WxBriefing.Live[this.manager_name];
        }
        this.parent(op);
        OCS.WxBriefing.Live[this.manager_name] = this;
    },
    destroy_manager: function () {
        OCS.WxBriefing.Live[this.manager_name] = null;
    }

}); // End OCS.Viewer.Classes.manager
